'use client';

import React, { useRef } from 'react';

import { Heading } from '../../../../components/Heading/Heading';
import { PostImageGrid } from '../../../../components/PostImageGrid/PostImageGrid';

import { getNodesFromConnection } from '../../../../helpers/graphql';
import { GetBrandPosts, GetBrandPosts_posts_edges_node } from '../../../../interfaces/graphql';
import { useClientHasRendered } from '../../../../helpers/hooks';
import { MAIN_NAVIGATION_MIN_HEIGHT } from '../../../../components/Navigation/MainNavigation/constants/constants';
import { usePostViewer } from '../../../../helpers/hooks/usePostViewer';
import { PostsViewer } from '../../../../components/PostsViewer/PostsViewer';

interface IProps {
  brandPosts: GetBrandPosts;
}

export const BrandPostsGrid = ({ brandPosts }: IProps) => {
  const totalGridPosts = 12;
  const clientHasRendered = useClientHasRendered();

  const postsReference = useRef<HTMLDivElement>(null);
  const {
    currentPostViewerId,
    closePostViewer,
    isPostViewerOpen,
    openPostViewer,
    setCurrentPostViewerId,
  } = usePostViewer(postsReference, MAIN_NAVIGATION_MIN_HEIGHT + 4);

  const posts = getNodesFromConnection<GetBrandPosts_posts_edges_node>(brandPosts.posts);
  const postsWithImages = posts.filter(p => p.images.totalCount > 0).slice(0, totalGridPosts);

  return (
    <section ref={postsReference}>
      <Heading variant="sm" className="mb-4">
        Recent Brand Posts
      </Heading>
      <PostImageGrid
        isLoading={!clientHasRendered}
        openPostViewer={openPostViewer}
        posts={postsWithImages}
      />
      {isPostViewerOpen && currentPostViewerId && (
        <PostsViewer
          posts={postsWithImages}
          currentPostViewerId={currentPostViewerId}
          hasMore={false}
          isPostViewerOpen
          loadMore={() => {}}
          onClosePostsViewer={closePostViewer}
          setCurrentPostViewerId={setCurrentPostViewerId}
        />
      )}
    </section>
  );
};
